import { pushToDataLayer } from '@app/infrastructure/gtm/pushToDataLayer';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { GtmInsuranceType } from '@app/domain/model/gtm/GtmInsuranceType';

export interface TravelStartCalculationData {
    beginDate: string;
    endDate: string;
    territoryCode: string;
    goalCode: string;
}

export function trackStartCalculation(data: TravelStartCalculationData): void {
    pushToDataLayer(GtmEventName.StartCalculation, {
        insurance_type: GtmInsuranceType.Travel,
        begin_date: data.beginDate,
        end_date: data.endDate,
        territory_code: data.territoryCode,
        goal_code: data.goalCode,
    });
}
